import * as yup from 'yup';

export const IncomingCheckValidationSchema = ({ amountCentsMax }: { amountCentsMax: number }) =>
  yup.object({
    amountCents: amountCentsMax
      ? yup
          .number()
          .typeError('Amount must be a number')
          .positive()
          .max(amountCentsMax, `Amount can not be more than ${amountCentsMax / 100}`)
          .required('This is required')
      : yup.number().typeError('Amount must be a number').positive().required('This is required'),
    payerType: yup.string().required('This is required'),
    category: yup.string().required('This is required'),
  });

export const IncomingCheckDepositValidationSchema = yup.object({
  checkDeposits: yup.array(IncomingCheckValidationSchema({ amountCentsMax: 0 })),
});
